<template>
  <CCard class="statistical-card">
    <CCardBody
      color="white"
      border-color="white"
      class="statistical-card__body"
    >
      <div class="statistical-card__title">
        {{ title }}
      </div>
      <div class="statistical-card__value">
        {{ cardValue }}
      </div>
    </CCardBody>
    <CCardFooter class="statistical-card__footer p-0" border-color="white">
      <CChartLineSimple
        style="height:50px"
        :background-color="chartOptions.colorBg"
        :border-color="chartOptions.colorStroke"
        :data-points="chartDataCopy"
        :options="{ elements: { line: { borderWidth: 2.5 } } }"
        :label="title"
      />
    </CCardFooter>

    <div v-if="loading" class="statistical-card_is-loading" />
  </CCard>
</template>
<script>
import { CChartLineSimple } from "@/charts";
import { convertNumberToDecimal } from "@/utils/convertNumberToDecimal";
const chartColors = ["success", "warning", "red", "blue", "blue-1"];

export default {
  name: "VStatisticalCard",

  components: {
    CChartLineSimple
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: "Title"
    },
    chartData: {
      type: Array,
      default: () => ([])
    },
    chartColor: {
      type: String,
      default: chartColors[0],
      validator: v => {
        return chartColors.indexOf(v) !== -1;
      }
    }
  },

  data: () => ({
    chartDataCopy: []
  }),

  created() {
    this.chartDataCopy = [...this.chartData]
  },

  computed: {
    cardValue() {
      return convertNumberToDecimal(this.value);
    },
    chartOptions() {
      return {
        colorBg: `chart-${this.chartColor}-bg`,
        colorStroke: `chart-${this.chartColor}-stroke`
      };
    }
  }
};
</script>
